import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const addTaskTemplate = createAsyncThunk(
  "TasksTemplates/addTaskTemplate",
  async (data, thunkAPI) => {
    let { handleSuccess, handleError, schema } = data;
    try {
      const resp = await axios.post(
        `${process.env.REACT_APP_BASE_URL}api/transactions/template`,
        schema,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (handleSuccess) {
        handleSuccess();
      }
      return resp.data;
    } catch (error) {
      if (error.response) {
        if (handleError) {
          handleError(
            error.response.data.errorMessage || error.response.data.message
          );
        }
        return thunkAPI.rejectWithValue(
          error.response.data.errorMessage || error.response.data.message
        );
      } else {
        if (handleError) {
          handleError(error.message);
        }
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
